<template>
    <div class="col-12">
        <div class="row no-gutters d-flex justify-content-space-evenly my-3">
            <button class="col-5 col-xl-2 filter-button">Last 30 Races</button>
            <button class="col-5 col-xl-2 filter-button">All Racecourses</button>
            <button class="col-5 col-xl-2 filter-button">All Distances</button>
            <button class="col-5 col-xl-2 filter-button">All Age</button>
            <button class="col-5 col-xl-2 filter-tag">Filter</button>
        </div>
        <div class="row no-gutters justify-content-start ml-2">
            <div class="col-11">
                <div class="row no-gutters align-items-center">
                    <div class="col-8 horse-details-wrapper">
                        <div class="row no-gutters">
                            <span class="font-weight-bold font-italic horse-name">{{selectedTrainer.name}}</span>
                        </div>
                        <span class="row no-gutters font-italic horse-details-text">{{selectedTrainer.name}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row no-gutters justify-content-center">
            <div class="col-12">
                <div class="row no-gutters justify-content-space-evenly team-details-table">
                    <div style="position: relative;" class="col-12 px-1">
                        <div class="table-responsive">
                            <table class="table">
                                <thead class="thead-dark">
                                <tr>
                                    <th scope="col">DATE</th>
                                    <th scope="col">CRS</th>
                                    <th class="d-none d-xl-table-cell" scope="col">REF</th>
                                    <th scope="col">RACE</th>
                                    <th scope="col">DIST</th>
                                    <th scope="col">HORSE</th>
                                    <th scope="col">JOCKEY</th>
                                    <th scope="col">MR</th>
                                    <th scope="col">WGT</th>
                                    <th scope="col">DRAW</th>
                                    <th scope="col">POS</th>
                                    <th scope="col">LTH</th>
                                    <th scope="col">TIME</th>
                                    <th scope="col">ADJ/TM</th>
                                    <th scope="col">OB</th>
                                    <th scope="col">SP</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(race, index) in selectedTrainer.previousRaces" :key="index">
                                    <td scope="row">{{race.date}}</td>
                                    <td class="highlighted-table-cell">{{race.course}}</td>
                                    <td class="d-none d-xl-table-cell">{{race.referenceAndGoing}}</td>
                                    <td>{{race.race}}</td>
                                    <td>{{race.distance}}</td>
                                    <td class="clickable-text" v-on:click="onHorseNameClicked(race.horse.horseId)">{{race.horse.name}}</td>
                                    <td class="clickable-text" v-on:click="onJockeyNameClicked(race.trainer.trainerId)">{{race.trainer.name}}</td>
                                    <td class="font-weight-bold">{{race.meritRating}}</td>
                                    <td>{{race.weight}}</td>
                                    <td>{{race.draw}}</td>
                                    <td class="text-center"><img :src="getImage('wf-finishing-position-' + race.position.value)" class="finishing-position-icon"  v-on:click="toggleFormGridVisibility(race.position.raceId)"></td>
                                    <td>{{race.lengthsBehind}}</td>
                                    <td>{{race.time}}</td>
                                    <td>{{race.adjustedTime}}</td>
                                    <td><sup>{{race.openingPrice.numerator}}</sup>&frasl;<sub>{{race.openingPrice.denominator}}</sub></td>
                                    <td><sup>{{race.startingPrice.numerator}}</sup>&frasl;<sub>{{race.startingPrice.denominator}}</sub></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex';
    import {TrainerStatisticsMockData} from '../assets/mockData/trainerStatistics';

    export default {
        name: 'TrainerStatistics',
        props: {
            selectedTrainer: Object,
            formGridToggleCallback: Function
        },
        methods: {
            getImage(imagePath, fileType) {
                if(fileType) return require('../assets/images/' + imagePath + '.' + fileType);
                return require('../assets/images/' + imagePath + '.svg');
            },
            toggleFormGridVisibility(selectedTrainer) {
                this.formGridToggleCallback(selectedTrainer);
            },
            onHorseNameClicked(horseNameId) {
                this.setSelectedHorse({});
                this.$router.push('/landing/statistics');
            },
            onJockeyNameClicked(jockeyNameId) {
                this.setSelectedJockey({});
                this.$router.push('/landing/statistics');
            },
            ...mapMutations(['setSelectedHorse', 'setSelectedJockey'])
        },
        mounted: function() {
            this.selectedTrainer = TrainerStatisticsMockData;
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .table td {
        padding-top: 0.4rem;
        padding-bottom: 0.4rem;
    }

    .jockey-silks {
        width: 5rem;
    }

    .bell-image {
        height: 1.7rem;
        margin-left: 0.2rem;
    }

    .horse-name {
        font-size: 1.3rem;
    }

    .highlighted-table-cell {
        background-color: #f2f2f2;
    }

    .table-responsive {
        border: 1px solid #7c7c7c !important;
        margin-bottom: 0.5rem !important;
        box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.4);
    }

    .team-details-table {
        margin-top: 0.6rem;
    }

    .finishing-position-icon {
        width: 1.4rem;
    }

    .horse-career-wrapper {
        border: solid 2px black;
        border-radius: 4px;
        line-height: 1rem;
        padding: 0.2rem 0;
    }

    .horse-career-wrapper table {
        width: 100%;
        text-align: center;
    }

    .horse-career-wrapper td {
        font-size: 0.55rem;
    }

    .horse-details-text {
        font-size: 0.7rem;
    }

    @media (min-width: 768px) {
        .finishing-position-icon {
            width: 1.8rem;
        }
    }

    @media only screen and (min-device-width: 0px) and (max-device-width: 1200px) and (orientation: landscape) {
        .horse-career-wrapper td {
            font-size: 1rem;
        }

        .jockey-silks {
            width: 7rem;
        }

        .horse-name {
            font-size: 1.7rem;
        }
    }

    @media (min-width: 1200px) {
        .table td {
            padding-top: 0.75rem;
            padding-bottom: 0.75rem;
        }

        .horse-name {
            font-size: 2rem;
        }

        .bell-image {
            height: 3rem;
            margin-left: 0.5rem;
        }

        .horse-career-wrapper td {
            font-size: 1.1rem;
            line-height: 1.6rem;
            padding: 0 1rem;
        }

        .jockey-silks {
            width: 9rem;
        }

        .horse-details-text {
            font-size: 1.05rem;
        }
    }
</style>
